import React, { CSSProperties, ForwardedRef, forwardRef } from 'react'
import LazyLoad from 'react-lazy-load'

type ImageProps = {
  src: string
  alt: string
  className?: string
  style?: CSSProperties
  width?: number | string
  height?: number | string
}

const Image = forwardRef(
  (
    { src, alt, className, style, width, height, ...other }: ImageProps,
    ref: ForwardedRef<HTMLImageElement>
  ) => (
    <LazyLoad offset={100}>
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        width={width}
        height={height}
        {...other}
        ref={ref}
      />
    </LazyLoad>
  )
)

Image.displayName = 'Image'

export default Image
